import { z } from "zod";

// Só flags S/N por enquanto; seções novas entram aqui conforme campos migrarem
// de Instituicao pra ConfiguracaoInstituicao.
export const configuracaoFormSchema = z.object({
  seCalcularDisponibilidadeEstoque: z.enum(["S", "N"]).nullish(),
  seCalcularDisponibilidadeVencimentoFichaAtual: z.enum(["S", "N"]).nullish(),
  seBuscarDadosEvolucaoAnterior: z.enum(["S", "N"]).nullish(),
  seLiberarSncr: z.enum(["S", "N"]).nullish(),
});

export type ConfiguracaoFormValues = z.infer<typeof configuracaoFormSchema>;
